import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
@Component({
    selector: 'app-shared404',
    templateUrl: './shared404.component.html',
    styleUrls: ['./shared404.component.css']
})
export class Shared404Component implements OnInit {

    constructor() { }
    WPSiteUrl = environment.WPsiteurl;
    ngOnInit() {
        $('body').addClass('error404')
    }

}

